/* eslint-disable no-param-reassign */
export default class MagicTabsBox {
	constructor({ elements }) {
		elements.forEach((el) => {
			const tabsHeaders = el.querySelectorAll('.magic-tabs__tab');
			const tabsContent = el.querySelectorAll('.magic-tabs__content');
			if (tabsHeaders.length > 0 && tabsContent.length > 0) {
				MagicTabsBox.activateFirstTab({ tabsContent, tabsHeaders });
				tabsHeaders.forEach((tabHeader) => {
					const { tabNr } = tabHeader.dataset;
					tabHeader.addEventListener('click', () => {
						MagicTabsBox.activateTab({
							tabHeader,
							tabNr,
							tabsHeaders,
							tabsContent,
							magicTabsBox: el,
						});
					});
				});
			}
		});
	}

	static activateFirstTab({ tabsHeaders, tabsContent }) {
		MagicTabsBox.setDefault({ tabsHeaders, tabsContent });
		const firstTabHeader = tabsHeaders[0];
		if (firstTabHeader != null) {
			firstTabHeader.classList.add('magic-tabs__tab--active');
			tabsContent[0].classList.remove('hidden');
		}
	}

	static setDefault({ tabsHeaders, tabsContent }) {
		tabsContent.forEach((tabContent) => {
			if (tabContent != null) {
				tabContent.classList.add('hidden');
			}
		});

		tabsHeaders.forEach((tabHeader) => {
			tabHeader.classList.remove('magic-tabs__tab--active');
		});
	}

	static activateTab({ tabHeader, tabNr, tabsHeaders, tabsContent, magicTabsBox }) {
		MagicTabsBox.setDefault({ tabsHeaders, tabsContent });
		const tabContentNr = magicTabsBox.querySelector(`.${tabNr}`);
		if (tabContentNr != null) {
			tabContentNr.classList.remove('hidden');
			tabHeader.classList.add('magic-tabs__tab--active');
		}
	}
}
